<template>
  <div id="app">
    <nav-bar :navBar="navBar"/>
    <router-view/>
    <hr/>
    <Footer/>
  </div>
</template>

<script>
import NavBar from './components/NavBar.vue'
import Footer from './components/Footer.vue'
import Wpp from './components/wpp.vue'
import { NavBarItems } from './model/navBar'
import ModalPoliticasDePrivacidade from './components/ModalPoliticasDePrivacidade.vue'
import { ContatoService } from './service/contatoService'
export default {
  components: { NavBar, Footer, Wpp, ModalPoliticasDePrivacidade },
  name: 'App',
  data () {
    return {
      navBar: new NavBarItems()
    }
  },
  beforeCreate () {
    ContatoService.ligarApi()
  },
  created () {
    this.setaMenuAtivo()
  },
  updated () {
    window.scrollTo(0, 0)
    this.setaMenuAtivo()
  },
  methods: {
    setaMenuAtivo () {
      this.navBar.items.forEach(e => {
        e.url === this.$route.fullPath ? e.ativo = true : e.ativo = false
      })
    }
  }
}
</script>

<style>
  @import './styles/fonts/stylesheet.css';
  @import url('https://fonts.googleapis.com/css2?family=Ubuntu:wght@400;700&display=swap');
h1,h2,h3,h4,h5,h6{
  font-family: 'titulo' !important;
}
*,span,p{
  font-family: 'Ubuntu', sans-serif;
}
:root{
  --cor-primaria: #2BD6A5;
  --cor-secondaria: #172026;
  --cor-terciaria: #FCFCFC;
}
.gap-xll{
  gap: 100px;
}
.gap-xl{
  gap: 75px;
}
.gap-lg{
  gap:50px;
}
.gap-md{
  gap: 35px;
}
.gap-sm{
  gap: 15px;
}
.btn-success {
    transition: all ease 0.4s;
}
label{
    font-size: 16px;
    font-weight: 500;
}

input,textarea,select{
    outline: none !important;
    border: none;
    padding: 5px 5px;
    border-bottom: 3px solid rgba(79,93,117,0.1) !important;
}

input:focus, textarea:focus,select:focus{
    outline: 2px solid rgba(79,93,117,0.1) !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue